<template>
    <div class="card">
        <!-- 説明文 -->
        <h2>{{ alt }}</h2>
        <BootstrapTable :data="myData" :options="myOptions" :columns="myColumns" />
    </div>
</template>

<script>
    export default {
        props: ['eqtlData', 'alt'],        
        data () {
            return {
                mySelections: [],
                myOptions: {
                    search: true, 
                    pagination: true,
                    paginationPreText: 'Previous',
                    paginationNextText: 'Next',
                    pageSize: 20,
                    pageList: [5, 10, 25, 50, 100, 200, "All"],
                    showColumns: true,
                    showPrint: false,
                    showExport: true,
                    exportDataType: 'all',
                    exportTypes: ['csv'],
                    filterControl: true,
                    toolbar: '#toolbar',
                    clickToSelect: true,
                    idField: 'id',
                    selectItemName: 'id',
                    sortName: 'eqtl_pval1',
                    sortOrder: 'asc',
                    exportOptions: {
                        fileName: function () {
                            return 'SNP_eQTL'
                        },
                        preventInjection: false
                    }
                },
                myColumns: [
                    { field: 'gene_symbol',
                      title: 'Gene Symbol',
                      filterControl: 'input',
                      formatter: function (value, row) {
                        return '<a href="' + row.gene_url + '">' + value + '</a>'
                        },
                      sortable: true,
                    },
                    { field: 'snp_id', title: 'SNP ID'},
                    { field: 'cell_type', title: 'Cell Type', sortable: false, filterControl: 'select'},
                    { field: 'chromosome', title: 'Chromosome', sortable: false},
                    { field: 'position', title: 'Position', sortable: false},
                    { field: 'eqtl_pval1', title: 'eQTL p-value', sortable: true},
                    { field: 'eqtl_effect_beta1', title: 'eQTL effect beta', sortable: true},
                    { field: 'eqtlplot',
                      title: 'eQTL plot',
                      formatter: function (value, row) {
                          return '<div class="plot"><a href="' + row.eqtlplot + '"><i class="far fa-image fa-lg"></i></a></div>'
                        },
                      forceHide: true,
                    },
                ],
                myData: [],
            }
        },
        created () {
            this.myData = JSON.parse(this.eqtlData)
        },
  }
</script>

<style>
    .plot {
        text-align: center;
    }
    td {
         padding: 12px !important;
    }
    .bootstrap-table .float-right {
        float: right;
    }
    .bootstrap-table .fixed-table-toolbar .columns-right {
        margin-left: 5px;
    }
    .bootstrap-table .page-list {
        display: inline-block;
    }
    .bootstrap-table .loading-text {
        display: none;
    }
</style>
